import { apiV1 } from "api-v2";
import type { AxiosResponse } from "axios";

import type { Company } from "newui/features/Company/types";

export const getCompanyProfile = (
	companyId: number,
	withPastProjects: boolean = true
): Promise<AxiosResponse<Company>> => {
	const baseUrl = `companies/${companyId}`;
	const url = withPastProjects
		? baseUrl
		: `${baseUrl}?past_projects_published=false`;

	return apiV1.get<Company>(url);
};

export const getCompanyAccountDetails = (
	companyId: number
): Promise<AxiosResponse<CompanyAccountDetails>> => {
	return apiV1.get<CompanyAccountDetails>(
		`companies/${companyId}/account-information`
	);
};
